import Vue from 'vue'
import Router from 'vue-router'
import '@/assets/css/reset.css'
import '@/assets/css/header.css'
import '@/assets/css/item.css'
import '@/assets/css/detail.css'


Vue.use(Router)

import Shop from '../views/shop'
import Home from '../views/home'
import Controller from '../views/pageController'
import RemoteKeys from '../views/pageRemoteKey'
import BleKeys from '../views/pageBleKey'
import PsLockPage from '../views/pagePassLock'
import Software from '../views/pageSoftware'
import Develop from '../views/pageDevelop'
import PageValve from '../views/pageValve'
import Contact from '../views/contact'
import Download from '../views/PageDownload'

import Item from '../components/item'

import ItemBlekey from '../components/item-blekey'
import ItemController from '../components/item-controller'
import ItemPslock from '../components/item-pslock'
import ItemRemotekey from '../components/item-remotekey'
import ItemSoftware from '../components/item-software'
import ItemDevelop from '../components/item-develop'
import ItemValve from '../components/item-valve'
import DetailBlekey from '../components/detail-blekey'
import DetailController from '../components/detail-controller'
import DetailPslock from '../components/detail-pslock'
import DetailRemotekey from '../components/detail-remotekey'
import DetailSoftware from '../components/detail-software'
import DetailDevelop from '../components/detail-develop'
import DetailValve from '../components/detail-valve'


export default new Router({
  routes: [
    {path:'/',component:Home},   
    {path:'/home',component:Home},
    {path:'/contact',component:Contact},
    {path:'/download',component:Download},
    {path:'/controller',component:Controller},
    {path:'/remotekey',component:RemoteKeys},
    {path:'/blekey',component:BleKeys},
    {path:'/passlock',component:PsLockPage},
    {path:'/software',component:Software},
    {path:'/develop',component:Develop},
    {path:'/shop',component:Shop},
    {path:'/valve',component:PageValve},
    {path:'/item',name:'item',component:Item},
    {path:'/itemblekey',name:'itemblekey',component:ItemBlekey},
    {path:'/itemcontroller',name:'itemcontroller',component:ItemController},
    {path:'/itempslock',name:'itempslock',component:ItemPslock},
    {path:'/itemremotekey',name:'itemremotekey',component:ItemRemotekey},
    {path:'/itemsoftware',name:'itemsoftware',component:ItemSoftware},
    {path:'/itemdevelop',name:'itemdevelop',component:ItemDevelop},
    {path:'/itemvalve',name:'itemvalve',component:ItemValve},
    {path:'/detailblekey',name:'detailblekey',component:DetailBlekey},
    {path:'/detailcontroller',name:'detailcontroller',component:DetailController},
    {path:'/detailpslock',name:'detailpslock',component:DetailPslock},
    {path:'/detailremotekey',name:'detailremotekey',component:DetailRemotekey},
    {path:'/detailsoftware',name:'detailsoftware',component:DetailSoftware},
    {path:'/detaildevelop',name:'detaildevelop',component:DetailDevelop},
    {path:'/detailvalve',name:'detailvalve',component:DetailValve},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js